import React, { useEffect, useRef, useState } from "react";
import { Alert, Input, Modal, Select, Space, Typography } from "antd";

const { Text } = Typography;

const SurePayStudentCodeModal = ({
  visible,
  onCancel,
  onSaved,
  searchStudents,
  addCode,
  student = null,
  mode = "add",
}) => {
  const [surePayStudentCode, setSurePayStudentCode] = useState("");
  const [studentId, setStudentId] = useState(null);
  const [studentOptions, setStudentOptions] = useState([]);
  const [searching, setSearching] = useState(false);
  const [saving, setSaving] = useState(false);
  const searchTimer = useRef(null);

  useEffect(() => () => clearTimeout(searchTimer.current), []);

  useEffect(() => {
    if (visible) {
      setSurePayStudentCode(
        mode === "change" ? student?.surePayStudentCode || "" : "",
      );
      setStudentId(student?.id || null);
      setStudentOptions(student ? [student] : []);
    }
  }, [mode, student, visible]);

  const loadStudents = async (search = "") => {
    if (!search.trim()) {
      setStudentOptions([]);
      return;
    }
    setSearching(true);
    try {
      setStudentOptions(await searchStudents({ search, limit: 30 }));
    } finally {
      setSearching(false);
    }
  };

  const handleSearch = (value) => {
    clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => loadStudents(value), 300);
  };

  const handleSave = async () => {
    const code = surePayStudentCode.trim();
    if (!code || !studentId) return;
    setSaving(true);
    try {
      const result = await addCode(code, studentId, mode === "change");
      if (result) {
        if (onSaved) onSaved(result);
        else onCancel();
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title={
        mode === "change"
          ? "Change SurePay code"
          : "Add SurePay code to student"
      }
      open={visible}
      onCancel={onCancel}
      onOk={handleSave}
      okText="Save code"
      confirmLoading={saving}
      okButtonProps={{ disabled: !surePayStudentCode.trim() || !studentId }}
      destroyOnClose
    >
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Input
          autoFocus
          value={surePayStudentCode}
          onChange={(event) => setSurePayStudentCode(event.target.value)}
          placeholder="Enter the SurePay student code"
          maxLength={150}
        />
      </Space>
    </Modal>
  );
};

export default SurePayStudentCodeModal;
